import "./styles.scss";

import * as Material from "@mui/material";
import { AddRounded, SettingsRounded, SlowMotionVideoRounded } from "@mui/icons-material";
import { IconArrowsSort } from "@tabler/icons-react";

import { Button } from "@fragments";


export default function ActionsRow({
    handleCreatePlaylist,
    handleReorderPlaylists,
    handleConfigureSession,
    canReorderPlaylists = false
}) {
    return (
        <div className="actions-row mb-6">
            <Button
                color="overlay"
                size="large"
                startIcon={<IconArrowsSort />}
                text="Reordenar playlists"
                onClick={handleReorderPlaylists}
                disabled={!canReorderPlaylists}
                tooltip={!canReorderPlaylists ? "Adicione ao menos duas playlists para reordenar" : undefined}
            />

            <Button
                color="overlay"
                size="large"
                startIcon={<SlowMotionVideoRounded />}
                endIcon={<AddRounded />}
                text="Adicionar playlist"
                onClick={handleCreatePlaylist}
            />

            <Material.Divider
                orientation="vertical"
                flexItem
                className="ml-2 mr-2"
            />

            <Button
                color="overlay"
                size="large"
                endIcon={<SettingsRounded />}
                text="Configurar sessão"
                onClick={handleConfigureSession}
            />
        </div>
    );
}

